define("settings/components/devices/device-item", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr>
    <td class="dd-privacy-mask-user-input">
      <strong>{{@device.name}}</strong>
      <br />
      <span class="u--text--light u--ellipsis">{{@device.ownerEmail}}</span>
    </td>
    <td>{{@device.addedAt}}</td>
    <td>
      {{#if @device.hasNotificationToken}}
        <button
          class="o--btn o--btn--primary {{if this.testNotification.isRunning 'o--btn--disabled'}}"
          onclick={{perform this.testNotification}}
          type="button"
        >
          {{t "account.devices.table.row.test_notification"}}
        </button>
      {{else}}
        <span class="u--text--light">{{@device.warningMessages}}</span>
      {{/if}}
    </td>
    <td>
      {{#if this.canDestroy}}
        <button class="o--btn o--btn--outline" disabled={{@device.isSaving}} onclick={{action @disconnect}} type="button">
          {{t "account.devices.table.row.disconnect"}}
        </button>
      {{/if}}
    </td>
  </tr>
  */
  {
    "id": "on3Rwsbs",
    "block": "[[[10,\"tr\"],[12],[1,\"\\n  \"],[10,\"td\"],[14,0,\"dd-privacy-mask-user-input\"],[12],[1,\"\\n    \"],[10,\"strong\"],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n    \"],[10,\"br\"],[12],[13],[1,\"\\n    \"],[10,1],[14,0,\"u--text--light u--ellipsis\"],[12],[1,[30,1,[\"ownerEmail\"]]],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,[30,1,[\"addedAt\"]]],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[30,1,[\"hasNotificationToken\"]],[[[1,\"      \"],[10,\"button\"],[15,0,[29,[\"o--btn o--btn--primary \",[52,[30,0,[\"testNotification\",\"isRunning\"]],\"o--btn--disabled\"]]]],[15,\"onclick\",[28,[37,1],[[30,0,[\"testNotification\"]]],null]],[14,4,\"button\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.devices.table.row.test_notification\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,1],[14,0,\"u--text--light\"],[12],[1,[30,1,[\"warningMessages\"]]],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[30,0,[\"canDestroy\"]],[[[1,\"      \"],[10,\"button\"],[14,0,\"o--btn o--btn--outline\"],[15,\"disabled\",[30,1,[\"isSaving\"]]],[15,\"onclick\",[28,[37,3],[[30,0],[30,2]],null]],[14,4,\"button\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.devices.table.row.disconnect\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@device\",\"@disconnect\"],false,[\"if\",\"perform\",\"t\",\"action\"]]",
    "moduleName": "settings/components/devices/device-item.hbs",
    "isStrictMode": false
  });
  let DeviceItemComponent = _exports.default = (_class = class DeviceItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _defineProperty(this, "testNotification", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            yield this.args.device.testNotification();
            this.alerts.success(this.intl.t('alerts.account.devices.test_notification.success.message'), {
              title: this.intl.t('alerts.account.devices.test_notification.success.title'),
              timeout: 5000
            });
          } catch (e) {
            this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
              title: this.intl.t('alerts.account.devices.test_notification.error.title')
            });
          }
        }
      }), null, "testNotification", null));
    }
    get canDestroy() {
      return !(this.args?.numberOfDevices <= 1 && this.auth.currentUserModel.isAccountOwner);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DeviceItemComponent);
});